import React from 'react';
import { Box } from '@mui/material';

import { modalFormSectionStyles as sectionStyles } from './modalV2.style';

const ModalFormSection = ({ title, children, styles = {} }) => {
  return (
    <Box sx={{ ...sectionStyles.wrapper, ...styles }}>
      {title && <Box sx={sectionStyles.title}>{title}</Box>}
      <Box sx={sectionStyles.content}>{children}</Box>
    </Box>
  );
};

export default ModalFormSection;
